import { createAction } from "redux-actions";

import { createAsyncAction } from "../helpers";

export const getRulesListAsyncAction = createAsyncAction(
	"GET_RULES_LIST_REQUEST",
	"GET_RULES_LIST_SUCCESS",
	"GET_RULES_LIST_FAILURE",
	"GET_RULES_LIST_CANCEL"
);

export const getRuleDetailAsyncAction = createAsyncAction(
	"GET_RULE_DETAIL_REQUEST",
	"GET_RULE_DETAIL_SUCCESS",
	"GET_RULE_DETAIL_FAILURE",
	"GET_RULE_DETAIL_CANCEL"
);

export const updateRuleAsyncAction = createAsyncAction(
	"PUT_RULE_REQUEST",
	"PUT_RULE_SUCCESS",
	"PUT_RULE_FAILURE",
	"PUT_RULE_CANCEL"
);

export const postRuleAsyncAction = createAsyncAction(
	"POST_RULE_REQUEST",
	"POST_RULE_SUCCESS",
	"POST_RULE_FAILURE",
	"POST_RULE_CANCEL"
);

export const deleteRuleAsyncAction = createAsyncAction(
	"DELETE_RULE_REQUEST",
	"DELETE_RULE_SUCCESS",
	"DELETE_RULE_FAILURE",
	"DELETE_RULE_CANCEL"
);

export const resetAction = createAction("RULES_RESET_ACTIONS");
